import React, { useEffect } from "react";
import "./css/fonts.css";
import "./css/layout.css";
import "./css/side.css";
import CabShell from "./CabShell";

/** Page wrapper: scoped class `cab-<name>` carries that wireframe's CSS. */
export default function CabPage({ name, unread, children }) {
  // lets the document scroll (see css/layout.css); removed again for legacy pages
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add("cab-active");
    return () => html.classList.remove("cab-active");
  }, []);
  return (
    <div className={`cab-${name} cab-root`} style={{ minHeight: "100vh" }}>
      <CabShell unread={unread} />
      {children}
    </div>
  );
}
